import React from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Helper',
  },
  {
    path: 'Texts',
    breadcrumbName: 'Texts',
  },
];

const VerticalAlignment = () => {
  return (
    <>

      <PageHeader title="Texts" breadcrumb={{ routes }} subTitle="Align" style={{ padding: 10 }} />

      <div className="MF_area">
        <span className="v_baseline">v_baseline</span>
        <span className="v_top">v_top</span>
        <span className="v_middle">v_middle</span>
        <span className="v_bottom">v_bottom</span>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<span class="v_baseline">v_baseline</span>
<span class="v_top">v_top</span>
<span class="v_middle">v_middle</span>
<span class="v_bottom">v_bottom</span>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>

    </>
  );
}

export default VerticalAlignment;
